/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

type Props = {
  children: React.ReactNode;
  className?: string;
  css?: Interpolation<Theme>;
};

const styles: Record<string, Interpolation<Theme>> = {
  pageContainer: () => css`
    position: relative;
    margin: 0 auto;
    padding: 0 16px;
    width: 100%;

    @media (min-width: ${breakpoints.values.md}px) {
      max-width: 1152px;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
      max-width: 1440px;
    }
  `,
};

function Container({ children, className, css: cssProp }: Props): React.ReactElement {
  return (
    <div css={[styles.pageContainer, cssProp]} className={className}>
      {children}
    </div>
  );
}

export default React.memo(Container);
